// Shown only when the page is not on a live host (PR previews, local builds). Never renders on the live portal.
import React from "react";
import { IS_LIVE, PREVIEW_MESSAGE } from "../lib/portalMode";

export default function PreviewNote({ inline = false, live = IS_LIVE }) {
  if (live) return null;
  const style = inline
    ? {
        margin: "0.75rem 0 0",
        padding: "0.6rem 0.85rem",
        borderRadius: "8px",
        background: "#fff7e6",
        border: "1px solid #f3c77a",
        color: "#7a4b00",
        fontSize: "0.9rem",
        fontWeight: 600,
        textAlign: "center",
      }
    : {
        position: "sticky",
        top: 0,
        zIndex: 1000,
        padding: "0.7rem 1rem",
        background: "#fff7e6",
        borderBottom: "2px solid #f3c77a",
        color: "#7a4b00",
        fontSize: "0.95rem",
        fontWeight: 700,
        textAlign: "center",
      };
  return (
    <div role="status" style={style} data-testid={inline ? "preview-note-inline" : "preview-note"}>
      {PREVIEW_MESSAGE}
    </div>
  );
}
